export function truncateText(text: string, maxLength: number, endCharsCount: number = 5): string {
  if (text.length <= maxLength) {
    return text;
  }

  const start = text.substring(0, maxLength - endCharsCount - 3);
  const end = text.substring(text.length - endCharsCount);
  return `${start}...${end}`;
}
